import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "panel"
}
const _hoisted_2 = { key: 2 }

import { computed, onBeforeMount, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import { Flash } from '@/core/Flash';
import auth from '@/core/Auth';
import { Partner, PartnerStub, usePartner } from '@/modules/partner/Partner';
import { useMe } from '@/modules/user/Me';
import { LawFirm, LawFirmCreate, useLawFirm } from '@/modules/law_firm/LawFirm';
import { ErrorBag, handleFormError, handleLoadError } from '@/core/common';
import PageLayout from '@/core/components/PageLayout.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppInput from '@/core/components/form/AppInput.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PartnerLawFirm',
  setup(__props) {

const { $gettext, interpolate } = useGettext();
const route = useRoute();
const store = useStore<AppStore>();
const meResource = useMe();
const partnerResource = usePartner();
const lawFirmResource = useLawFirm();
const authUser = computed(() => store.state.authenticatedUser);
const canCreate = computed<boolean>(() => auth.can('LAW_FIRM_CREATE'));
const partner = ref<Partner | PartnerStub | null>(null);
const pageTitle = computed(() => interpolate(
	$gettext('Extern partner för %{ name }'),
	{name: partner.value?.name || ''},
));
const showNewForm = ref<boolean>(false);
const newLawFirm = ref<LawFirmCreate>({
	identity_number: '',
	name: '',
	user: true,
	invite_user_email: '',
});
const errors = ref<ErrorBag>({});
const foundLawFirm = ref<LawFirm | undefined>();

const load = async () => {
	if (authUser.value?.partner) {
		try {
			partner.value = await meResource.getPartner();
		} catch (e) {
			handleLoadError(e as Error, 'dashboard');
		}

	} else if (route.params.id) {
		try {
			partner.value = await partnerResource.get(route.params.id as string);
		} catch (e) {
			handleLoadError(e as Error, 'partner.index');
		}
	}
};

watch(route, () => {
	if (route.params.id) {
		load();
	}
});
onBeforeMount(load);

const resetLawFirm = () => {
	if (!partner.value) {
		return;
	}

	partner.value.primary_law_firm = undefined;
};

const search = async () => {
	const searchResult = await lawFirmResource.getAllNoPagination({
		identity_number: newLawFirm.value.identity_number,
	});

	if (searchResult.length > 0) {
		foundLawFirm.value = searchResult[0];
	} else {
		showNewForm.value = true;
	}
};

const saveSelection = async () => {
	if (!partner.value || !foundLawFirm.value) {
		return;
	}

	try {
		if (authUser.value?.partner) {
			partner.value = await meResource.putPrimaryLawFirm(foundLawFirm.value.id);

		} else if (route.params.id) {
			partner.value = await partnerResource.putPrimaryLawFirm(partner.value.id, foundLawFirm.value.id);
		}

		Flash.success($gettext('Val av extern partner har sparats.'));
	} catch (e) {
		handleFormError(e as Error, errors);
	}
};

const saveNew = async () => {
	if (!partner.value) {
		return;
	}

	try {
		partner.value.primary_law_firm = await lawFirmResource.post(newLawFirm.value);
		foundLawFirm.value = partner.value.primary_law_firm as LawFirm;

		Flash.success($gettext('En inbjudan har skickats till e-postadressen du angav.'));
		await saveSelection();

	} catch (e) {
		handleFormError(e as Error, errors);
	}
};

const save = () => {
	if (foundLawFirm.value) {
		saveSelection();
		return;

	} else if (showNewForm.value) {
		saveNew();
		return;
	}

	search();
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, { "page-title": pageTitle.value }, _createSlots({ _: 2 }, [
    (partner.value !== null)
      ? {
          name: "content",
          fn: _withCtx(() => [
            (partner.value.primary_law_firm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _withDirectives((_openBlock(), _createElementBlock("p", null, [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" Er nuvarande externa partner: %{ name } (%{ identity_number }) ", -1)
                  ]))])), [
                    [_directive_translate, {
						name: partner.value.primary_law_firm.name,
						identity_number: partner.value.primary_law_firm.identity_number,
					}]
                  ]),
                  _createElementVNode("p", null, [
                    _createVNode(AppButton, {
                      onClick: _withModifiers(resetLawFirm, ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("Jag vill byta extern partner", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("form", {
                  key: 1,
                  class: "panel",
                  onSubmit: _withModifiers(save, ["prevent"])
                }, [
                  _createVNode(AppFormGroup, {
                    id: "partner_law_firm_identity_number",
                    label: _unref($gettext)('Sök organisationsnummer'),
                    errors: errors.value.identity_number
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppInput, {
                        id: "partner_law_firm_identity_number",
                        modelValue: newLawFirm.value.identity_number,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newLawFirm.value.identity_number) = $event)),
                        required: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label", "errors"]),
                  (showNewForm.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _withDirectives((_openBlock(), _createElementBlock("p", null, [...(_cache[5] || (_cache[5] = [
                          _createTextVNode(" Vi kunde inte hitta en extern partner med det organisationsnummer. ", -1)
                        ]))])), [
                          [_directive_translate]
                        ]),
                        (canCreate.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _withDirectives((_openBlock(), _createElementBlock("p", null, [...(_cache[6] || (_cache[6] = [
                                _createTextVNode(" Du kan bjuda in partnern här. ", -1)
                              ]))])), [
                                [_directive_translate]
                              ]),
                              _createVNode(AppFormGroup, {
                                id: "partner_law_firm_name",
                                label: _unref($gettext)('Namn'),
                                errors: errors.value.name
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(AppInput, {
                                    id: "partner_law_firm_name",
                                    modelValue: newLawFirm.value.name,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newLawFirm.value.name) = $event)),
                                    required: ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label", "errors"]),
                              _createVNode(AppFormGroup, {
                                id: "partner_law_firm_invite_user_email",
                                label: _unref($gettext)('E-postadress till ansvarig person'),
                                errors: errors.value.invite_user_email
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(AppInput, {
                                    type: "email",
                                    id: "partner_law_firm_invite_user_email",
                                    modelValue: newLawFirm.value.invite_user_email,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newLawFirm.value.invite_user_email) = $event)),
                                    required: ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label", "errors"]),
                              _createElementVNode("p", null, [
                                _createVNode(AppButton, { type: "submit" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_translate, null, {
                                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                        _createTextVNode("Spara", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (foundLawFirm.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _withDirectives((_openBlock(), _createElementBlock("p", null, [...(_cache[8] || (_cache[8] = [
                            _createTextVNode(" Vi hittade extern partner med namnet %{ name }. ", -1)
                          ]))])), [
                            [_directive_translate, {name: foundLawFirm.value.name}]
                          ]),
                          _createElementVNode("p", null, [
                            _createVNode(AppButton, { type: "submit" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_translate, null, {
                                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                    _createTextVNode("Välj", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock("p", _hoisted_2, [
                          _createVNode(AppButton, { type: "submit" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_translate, null, {
                                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                  _createTextVNode("Sök", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]))
                ], 32))
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["page-title"]))
}
}

})